module.exports = __webpack_public_path__ + "static/media/t22.8e0fe8f4.jpg";